<!-- 
    FORM PARA INCLUSAO DE ETIQUETAS
-->

<script>
import { apiORDSpost, apiORDS } from '../shared/api-functions'
import InputColor from '../components/input-color'
import { SysVars } from '../main';
import Vue from 'vue';

import apiCrm from '../api/api-crm.js'

export default {
    props: {
        index: '',
        tptag: '',
        crud: '',
    },

    components: {
        InputColor
    },

    data () {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            tagcrm: {...this.$store.getters.getEntities.tagcrm},
            params: {
                label: this.$store.getters.getEntities.metadata.tagcrm.cor.label,
                edit: false,
                list: [
                    { value: '#2196f3', title: '', cor: '#2196f3' },
                    { value: '#ff7300', title: '', cor: '#ff7300' },
                    { value: 'red', title: '', cor: 'red' },
                    { value: 'black', title: '', cor: 'black' },
                    { value: 'gray', title: '', cor: 'gray' },
                    { value: 'silver', title: '', cor: 'silver' },
                    { value: 'purple', title: '', cor: 'purple' }
                ],
            },
            selectedCor: '',
        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        title: function () {
            if (this.index) 
                return 'Alterar Etiqueta'
            else
                return 'Incluir Nova Etiqueta'
        }
    },

    methods: {
        handleSalvar () {
            this.tagcrm.tptag = this.tptag

            var valido = true;

            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Corrija os erros de preenchimento para continuar!')
                } else if (valido) {
                    this.apiTag(this.tagcrm, this.tagcrm.codtag, this.callBackPost)
                }
            })
        },

        callBackPost (tag) {
            if (this.index)
                this.$erpToastSuccess('Etiqueta alterada')
            else
                this.$erpToastSuccess('Novo etiqueta inserida')
            this.closeForm(tag)
        },

        closeForm (tag) {
            this.$emit('closeform', tag)
        },

        async loadData () {
            if (!this.index)
                return

            await this.$store.dispatch('loadTagCrm', { id: this.index } )
            if (this.$store.getters.getTagCrm) {
                this.tagcrm = {...this.$store.getters.getTagCrm}
            }
        },

    },

    watch: {

    },

    mounted () {
        this.$nextTick(function () {
            if (this.$refs.descricao) {
               this.$refs.descricao.focus()
            }
        })
    },

    created () {
        this.loadData()
    }

}

</script>

<template>
    <div class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container" style="width: 600px; max-width: 100%">
            <div class="nb-modal-header">
                <div class="row">
                    <div class="col">
                        <h4 class="def-title">{{ title }} </h4>
                    </div>
                </div>
            </div>
            <div class="nb-modal-scrollable-body">
                <div class="row">
                    <form-field ref="descricao" v-model="tagcrm.descricao" case="normal" type="text" col="12" :metadata="metadata.tagcrm.descricao" 
                        name="descricao" :v-errors="errors" v-validate="metadata.tagcrm.descricao.validator"></form-field>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6 col-12">
                        <input-color v-model="tagcrm.cor" :params="params"></input-color>
                    </div>
                </div>
            </div>
            <div class="row col mb-3">
                <v-button label="Salvar" :nb-btdef="true" @click="handleSalvar"></v-button>
                <v-button label="Cancelar" @click="closeForm"></v-button>
            </div>
        </div>
    </div>

</template>

<style>

</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-tag-form.vue